import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { defaultSmallPadding, isLargeWithOthers, isOnlyLarge } from "../CardDiscount/CardDiscount.styles";
var templateAreasSm = "\n\"img title\"\n\"img extra\"\n\"img vlp\"\n\"img price\"\n";
var templateAreasMd = "\n\"img\"\n\"title\"\n\"extra\"\n\"vlp\"\n\"price\"\n";
var templateAreasLg = "\n\"img\"\n\"title\"\n\"extra\"\n\"price\"\n";
export var root = {
  sm: {
    maxWidth: '100%',
    gridTemplateAreas: templateAreasSm,
    gridTemplateColumns: '90px 1fr'
  },
  md: {
    maxWidth: '200px',
    gridTemplateAreas: templateAreasMd,
    gridTemplateColumns: '1fr'
  },
  lg: {
    maxWidth: '315px',
    gridTemplateAreas: templateAreasLg,
    gridTemplateColumns: '1fr'
  }
};
// image labels

// discountWrapper
export var discountWrapperSm = {
  width: '100%',
  justifyContent: 'center'
};
export var discountWrapperLg = {
  justifyContent: 'flex-start',
  flexGrow: 1
};
export var discountWrapperMediaLg = {
  '@media(min-width: 1024px)': discountWrapperLg
};
export var getDiscountWrapperStyles = function getDiscountWrapperStyles(sizes) {
  if (isOnlyLarge(sizes)) return discountWrapperLg;
  if (isLargeWithOthers(sizes)) return _objectSpread(_objectSpread({}, discountWrapperSm), discountWrapperMediaLg);
  return discountWrapperSm;
};

// deliveryMode
export var deliveryModeSm = _objectSpread({
  width: '100%',
  fontSize: '3xs'
}, defaultSmallPadding);
export var deliveryModeLg = {
  width: 'fit-content',
  padding: '1em 2em',
  fontSize: 'inherit'
};
export var deliveryModeMediaLg = {
  '@media(min-width: 1024px)': deliveryModeLg
};
export var getDeliveryModeStyles = function getDeliveryModeStyles(sizes) {
  if (isOnlyLarge(sizes)) return deliveryModeLg;
  if (isLargeWithOthers(sizes)) return _objectSpread(_objectSpread({}, deliveryModeSm), deliveryModeMediaLg);
  return deliveryModeSm;
};